import { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { apiGetById } from '../../services/genesisApi/httpsMethods';
import type { Source } from '../../types/deal';
import { InfoSection } from '../../components/common/infoSection';
import "../../assets/css/Text-General.css";
import { numberFormatter } from '../../utils/numberFormatter';

interface SourceDetailProps {
  sourceId: number;
  isEdit: boolean;
}

const SourceDetail = ({ sourceId, isEdit }: SourceDetailProps) => {
  const [source, setSource] = useState<Source | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!sourceId) return;
    apiGetById('source', sourceId)
      .then((response) => {
        if (response && response.success && response.data) {
          setSource(response.data[0]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching source', err);
        setLoading(false);
      });
  }, [sourceId]);

  if (loading) return <CircularProgress />;
  if (!source) return <Typography>No Source found</Typography>;

  return (
    <Box sx={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        {isEdit ? (
          <Box sx={{ width: '75%', display: 'flex', gap: 1 }}>
            <Typography
              className="text-general-page-header-prefix"
              sx={{ mb: "0 !important", paddingBottom: "0 !important" }}
            >
              {"SOURCE:"}
            </Typography>
            <Typography
              className="text-general-page-header"
              sx={{ mb: "0 !important", paddingBottom: 0 }}
            >
              {source.source_name}
            </Typography>
          </Box>
        ) : null}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, width: '100%' }}>
        <InfoSection
          title="Overview"
          items={[
            { label: 'Source', value: source.source_name, link: `/sources/${source.id}` },
            { label: 'Type', value: source.source_type ?? '-' },
            { label: 'Deals', value: source.deal_count ?? '-' },
            { label: 'Killed Deals', value: source.killed_deals ?? '-' },
            { label: 'Total Loan Amount (FF, GBP)', value: typeof source.total_loan_amount_fully_funded === 'number' ? numberFormatter({ value: source.total_loan_amount_fully_funded }) : '-' },
          ]}
        />
      </Box>
    </Box>
  );
};

export default SourceDetail;


